import { CodeStatuses } from '../../../../../../../../../../../constants/codes';

const quickFilters = [
  {
    name: 'codeApplied',
    nestedPath: 'codes',
    searchKey: 'codes.id',
    data: [],
    selected: [],
    pageInfo: null,
    placeholder: 'Code Applied',
    idKey: 'id',
    labelKey: 'letter'
  },
  {
    name: 'codeStatus',
    nestedPath: 'codes',
    searchKey: 'codes.status.keyword',
    data: Object.values(CodeStatuses).map(status => ({
      status,
      label: status.replace('-', ' ')
    })),
    selected: [],
    pageInfo: null,
    placeholder: 'Code Status',
    idKey: 'status',
    labelKey: 'label'
  }
];

export default quickFilters;
